import '@fullcalendar/react/dist/vdom';
import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RootStoreProvider, CalendarStoreProvider } from '@uplift/providers';
import { CalendarStore } from '@uplift/store';
import { AlertProvider, applyGlobalStyles } from '@uplift/ui-v2';
import { LocalStorageService } from '@uplift/services';
import { restClient } from '@uplift/api';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { environment } from './environments/environment';
import { App } from './app/app';
import { rootStore } from './app/rootStore';
import { EnvironmentProvider } from '@uplift/contexts';
import { ModalsProvider } from './app/hooks/modal';

applyGlobalStyles();

LocalStorageService.setAppNameSpace(environment.appNameSpace);

const calendarStore = new CalendarStore();

restClient.configure({
  apiEndpoint: environment.restApi,
  authClient: rootStore.authClient,
  authStore: rootStore.authStore,
  authRedirectFallback: environment.authUrl,
});
const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      networkMode: 'always',
    },
    queries: {
      networkMode: 'always',
      refetchInterval: false,
      refetchIntervalInBackground: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
  }
});


declare global {
  interface Window {
    dataLayer: any[]; // eslint-disable-line @typescript-eslint/no-explicit-any
  }
}


ReactDOM.render(
  <React.StrictMode>
    <EnvironmentProvider environment={environment}>
      <ModalsProvider>
        <RootStoreProvider rootStore={rootStore}>
          <CalendarStoreProvider calendarStore={calendarStore}>
            <AlertProvider>
              <QueryClientProvider client={queryClient}>
                <ReactQueryDevtools />
                <App />
              </QueryClientProvider>
            </AlertProvider>
          </CalendarStoreProvider>
        </RootStoreProvider>
      </ModalsProvider>
    </EnvironmentProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
